<template>
  <div ref="searchIpt" class="search-ipt" :class="[{ showSearchBtn: showSearchBtn, small: isHeader }, Cl_type]">
    <el-icon v-if="isHeader" class="search-icon" size="20" style="vertical-align: middle">
      <Search />
    </el-icon>
    <el-input ref="searchInput" v-loading="state.loading" class="input" :disabled="state.loading"
      v-model="state.searchForm.search" @change="handleChange" @keyup.enter="searchHandle"
      :placeholder="state.searchHolder">
      <template #suffix>
        <div v-if="hasShopLogo && !state.searchForm.search" class="logo-block">
          <img class="logo-img" src="@/assets/images/home/taobao-ipt.png" />
          <img class="logo-img" src="@/assets/images/home/alibaba-ipt.png" />
          <img class="logo-img" src="@/assets/images/home/dian-ipt.png" />
        </div>
        <el-icon v-if="state.searchForm.search" @click="state.searchForm.search = ''" class="clearSearch">
          <CircleCloseFilled />
        </el-icon>
        <span>
          <ImgSearchGoods :uploadLoading="state.uploadLoading" ref="imgSearchGoodsRef"
            @base64ImgToSearch="base64ImgToSearch" class="Cl-img-search-goods">
          </ImgSearchGoods>
        </span>
      </template>
      <template #append v-if="showSearchBtn">
        <el-button :loading="state.loading" type="primary" @click="searchHandle"><el-icon class="search-btn"
            style="vertical-align: middle">
            <Search />
          </el-icon>{{ t('form.button.search') }}</el-button>
      </template>
    </el-input>
  </div>
</template>

<script setup>
import { useSearch } from '@/hooks/useSearch'
import { computed, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
import ImgSearchGoods from '../ImageSeacrhGoods'
const { state, searchHandle, handleChange, base64ImgToSearch } = useSearch()

defineProps({
  popoverWidth: {
    type: Number,
    default: 980,
  },
  showSearchBtn: {
    type: Boolean,
    default: true,
  },
  Cl_type: {
    type: String,
    default: 'home_search',
  },
  isHeader: {
    type: Boolean,
    default: false,
  },
  hasShopLogo: {
    type: Boolean,
    default: false,
  },
})

const { t } = useI18n()
const typeList = computed(() => {
  return [
    {
      value: 'product',
      label: t('home.product'),
      holder: t('home.productHolder'),
    },
    {
      value: 'shop',
      label: t('home.shop'),
      holder: t('home.shopHolder'),
    },
  ]
})
const getLocalSearchType = () => {
  return localStorage.getItem(state.searchType)
}
const formatHolder = () => {
  const type = getLocalSearchType()
  state.searchForm.searchType = type ? type : typeList.value[0]['id']
  state.searchHolder = type
    ? typeList.value.filter((i) => type === i.value)[0]['holder']
    : typeList.value[0]['holder']
}

// const handleSearchType = (value) => {
//   if (value) {
//     localStorage.setItem(state.searchType, value);
//   } else {
//     localStorage.removeItem(state.searchType);
//   }
//   state.searchHolder = typeList.value.filter((i) => value === i.value)[0][
//     "holder"
//   ];
//   handleBlur();
// };

formatHolder()
</script>
<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.search-ipt.home_search {
  width: 748px;
  height: 80px;
  border-radius: 944px;
  background: var(--white-color-1);
  overflow: hidden;
  display: flex;
  align-items: center;

  .input {
    font-size: 24px;
    height: 100%;
    border: none;

    ::v-deep {
      .el-input__inner {
        padding-right: 10px;
        height: 80px;

        &::placeholder {
          font-size: 18px;
          color: $gray-color;
        }
      }

      .search-btn {
        width: 24px;
        height: 24px;
        margin-right: 12px;

        svg {
          width: 24px;
          height: 24px;
        }
      }

      .el-input__wrapper {
        background: var(--white-color-1);
        box-shadow: none;
        padding-left: 40px;
        padding-right: 34px;
        height: 100%;
      }
    }
  }

  ::v-deep .el-input-group__prepend {
    background-color: var(--white-color-1);
    font-size: 32px;
  }

  ::v-deep .el-input__suffix {
    position: relative;

    .clearSearch {
      cursor: pointer;
      width: 30px;
      height: 30px;
      margin-right: 30px;
      font-style: 40px;
      color: var(--black-color-9);
    }

    .el-upload,
    .upload-demo {
      width: 28px;
      height: 28px;

      .el-upload-dragger {
        width: 100%;
        height: 100%;
        border: none;

        .pd-tupian {
          font-size: 28px !important;
          width: 28px;
          height: 28px;
        }
      }
    }
  }
}

.search-ipt.home_search.small {
  width: 320px;
  height: 48px;
  border-radius: 676px;
  background: var(--line-light-gray-color-1);
  overflow: hidden;
  margin-right: 20px;
  display: flex;
  align-items: center;
  border: 1px solid var(--white-color-1-light);

  .search-icon {
    color: var(--black-color-9);
    margin-left: 14px;
  }

  .input {
    font-size: 16px;
    height: 100%;
    border: none;
    color: var(--black-common-color-9);

    ::v-deep {
      .el-input__inner {
        padding-right: 0px;
        height: 48px;
        line-height: 48px;
        border: none;
        color: var(--black-color-9);

        &::placeholder {
          color: $gray-color;
          font-size: 13px;
        }
      }

      .el-input__wrapper {
        background: transparent;
        padding-left: 6px;
        padding-right: 12px;
        box-shadow: none;
        height: 100%;
        border: none;
      }
    }
  }

  .clearSearch {
    cursor: pointer;
    width: 14px;
    height: 14px;
    margin-right: 5px;
    color: var(--black-color-9);
  }

  ::v-deep {

    .el-upload,
    .upload-demo {
      width: 20px;
      height: 20px;

      .el-upload-dragger {
        width: 100%;
        height: 100%;
        border: none;

        .pd-tupian {
          font-size: 20px !important;
          width: 20px;
          height: 20px;
        }
      }
    }
  }
}

.showSearchBtn {
  ::v-deep {
    .el-input-group__append {
      width: 170px;
      text-align: center;
      background-color: var(--primary-color);
      font-size: 32px;
      color: var(--white-color-1-light);
      padding: 0px;
      height: 72px;
      line-height: 72px;
      min-height: 72px;
      margin-top: 4px;
      cursor: pointer;
      border-radius: 80px;
      margin-right: 4px;
      box-shadow: none;

      .el-button {
        height: 72px;
        width: 170px;
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}

.search-ipt {
  ::v-deep {
    .el-input__suffix {
      display: flex;
      align-items: center;
    }

    .el-input__suffix-inner {
      display: flex;
      align-items: center;
    }

    .el-loading-mask {
      background-color: rgba($color: var(--white-color-1), $alpha: 0.5);
    }
  }
}

.logo-block {
  display: flex;
  align-items: center;
  margin-right: 20px;

  .logo-img {
    width: 30px;
    height: 30px;
    margin-left: 12px;
  }
}
</style>
